<template>
  <section id="dialog" style="background-color: rgba(229,243,252,0.5); " class="pb-8 pt-10">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="9" xl="9">
          <div class="text-center mt-4">
            <h1 class="section-title font-weight-light">Получить бесплатную консультацию</h1>
          </div>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" md="5" xl="4">
          <p class="pt-2 text-center" style="color: #505050; font-weight: 500;">Эксперт свяжется с вами</p>
          <v-form ref="form" class="pa-4" @submit.prevent="handleSubmit">
            <v-text-field
                v-model="form.fio"
                name="fio"
                label="Введите имя"
                :error-messages="fioErrors"
                @input="$v.form.fio.$touch()"
                @blur="$v.form.fio.$touch()"
            ></v-text-field>
            <v-text-field
                v-model="form.phone"
                name="phone"
                label="Введите телефон"
                :error-messages="phoneErrors"
                @input="$v.form.phone.$touch()"
                @blur="$v.form.phone.$touch()"
            ></v-text-field>
            <v-checkbox
                class="offer-checkbox"
                v-model="form.offer"
                name="offer"
            >
              <template v-slot:label>
                <div>
                  Принимаю условия <a   @click.stop href="/offer.html">Публичной оферты</a> и <a  @click.stop href="/policy.html">Политикой конфиденциальности</a>, даю согласие
                  на обработку персональных данных.
                </div>
              </template>
            </v-checkbox>

            <div class="text-center">
<!--              <v-btn tile outlined color="#005096" class="mr-2" @click="dialog = false">-->
<!--                Закрыть-->
<!--              </v-btn>-->
              <v-btn :disabled="!form.offer" block tile color="#c42234" class="mr-4 white--text" type="submit">
                Получить Консультацию
              </v-btn>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
const querystring = require("querystring");
import {validationMixin} from "vuelidate";
import {required, email, minLength, sameAs} from "vuelidate/lib/validators";

export default {
  name: 'CallDialog',
  data() {
    return {
      dialog: false,
      form: {
        type: "dialog",
        phone: "",
        fio: "",
        offer: false
      },
    };
  },
  validations: {
    form: {
      phone: {required},
      fio: {required},
      offer: {required},
    }
  },
  computed: {
    fioErrors() {
      const errors = [];
      if (!this.$v.form.fio.$dirty) return errors;
      !this.$v.form.fio.required && errors.push("Обязательное поле.");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.form.phone.$dirty) return errors;
      !this.$v.form.phone.required && errors.push("Обязательное поле.");
      return errors;
    },
    offerErrors() {
      const errors = [];
      if (!this.$v.form.offer.$dirty) return errors;
      !this.$v.form.offer.required && errors.push("Обязательное поле.");
      return errors;
    },
  },
  methods: {
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try {
        await this.$ajax.post("https://nalog-service.site/email.php", querystring.stringify(this.form));
        this.$root.$emit('show-info', 'Спасибо за вашу заявку. Специалист свяжется с вами в ближайшее время')
        this.$refs.form.reset()
        setTimeout(() => {
          this.$v.$reset()
        }, 0)
      } catch (err) {
      }
    }
  }
};
</script>

<style lang="scss">
.offer-checkbox {
  .v-label {
    font-size: 12px;
  }
}
</style>
